import React, { ReactNode } from 'react';
import classnames from 'classnames';

import styles from './Tabs.module.css';

export type Tab<T extends string | number = string> = {
    id: T;
    label: ReactNode;
};

interface TabsProps<T extends string | number = string> {
    className?: string;
    tabs: readonly Tab<T>[];
    activeTab: T;
    onChange: (id: T) => void;
}

export const Tabs = <T extends string | number = string>({
    className,
    tabs,
    activeTab,
    onChange,
}: TabsProps<T>) => (
    <nav className={classnames(styles.tabs, className)}>
        {tabs.map((tab) => (
            <button
                key={tab.id}
                type="button"
                className={classnames(styles.tab, { [styles.active]: activeTab === tab.id })}
                onClick={() => onChange(tab.id)}
            >
                {tab.label}
            </button>
        ))}
    </nav>
);
